module.exports = __webpack_public_path__ + "img/sliders-04.7bca21cc.jpg";